import { ExpertModel, ModuleBaseModel, ModuleSectionPropsModel } from '@/types';
import ExpertsListingModuleGrid from './ExpertsListingModuleGrid';
import ExpertsListingModuleCarousel from './ExpertsListingModuleCarousel';
import { MetadataContext } from '@/components';
import { useContext } from 'react';
import ExpertsListingModuleGridApp from './ExpertsListingModuleGridApp';

export type ExpertsListingModuleModel = ModuleBaseModel<
  {
    layout?: 'Grid' | 'Carousel' | '';
    cta?: string;
    showTypeFilter?: boolean;
    experts: ExpertModel[];
  } & ModuleSectionPropsModel
>;

const ExpertsListingModule = (data: ExpertsListingModuleModel) => {
  const { layout } = data.props;
  const { isPublic } = useContext(MetadataContext);

  if (layout === 'Carousel') {
    return <ExpertsListingModuleCarousel {...data} />;
  } else {
    return isPublic ? <ExpertsListingModuleGrid {...data} /> : <ExpertsListingModuleGridApp {...data} />; // Grid layout
  }
};

export default ExpertsListingModule;
